export const getPersonalAccountByNetwork = (personalAccounts, network) =>
  personalAccounts.find(pa => pa.vanity_identifier.includes(network));

// If visa is an available network, we want to have this as option #1 selected
// eslint-disable-next-line consistent-return
export const getInitialNetwork = networks => {
  if (networks.includes('visa')) return 'visa';
  if (networks.includes('eft')) return 'eft';
  if (networks.includes('etransfer')) return 'etransfer';
};

// Program config flags that each enable at least one transfer type.
// Kept in one place so the Transfers page and the nav menu agree on what
// "transfers enabled" means.
export const TRANSFER_CONFIG_KEYS = [
  'allow_personal_bank_account_transfers',
  'allow_person_to_person_transfers',
  'allow_account_to_account_transfer',
  'allow_child_cards',
  'allow_interac_pull_transfers',
  'allow_external_transfers_v2',
  'allow_etransfer_push_v2',
];

// True when the program has at least one transfer type enabled
export const hasTransfersEnabled = configs =>
  Boolean(configs) && TRANSFER_CONFIG_KEYS.some(key => Boolean(configs[key]));
